import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-view" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "tit-h2" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "btn-group" }
const _hoisted_6 = {
  key: 0,
  class: "content-box task"
}
const _hoisted_7 = { class: "img-area" }
const _hoisted_8 = {
  key: 0,
  class: "desc"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "img-area" }
const _hoisted_11 = {
  key: 0,
  class: "desc"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "img-area" }
const _hoisted_14 = {
  key: 0,
  class: "desc"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "img-area" }
const _hoisted_17 = {
  key: 0,
  class: "desc"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "btn-group" }
const _hoisted_20 = { class: "section" }

import {ref, reactive, computed, onMounted, watch, type Ref } from "vue";
import { useRouter } from "vue-router";
import { useRequestStore } from "@/stores/request";
import { RequestTypeKeys, RequestStatusKeys, DocumentTypeKeys } from "@/types/constants";
import { FormTask } from '@/types/Form';
import { RequestInfo } from '@/types/Request';
import { getRequestInfo, uploadImagetoServer, updateTask, removeRequest, modifyRequest } from "@/api";
import { disablePastDates, getTagColor} from "@/utils";
import { getRequestStatusTypeValue, getDocumentTypeValue }  from '@/utils/getValueForKey';
import { ElMessageBox, ElNotification, ElMessage } from 'element-plus';
import moment from 'moment-timezone';
import CommonLoader from '@/components/CommonLoader.vue';
import ViewDetail from "@/components/ViewDetail.vue";
import HistoryList from '@/components/HistoryList.vue';
import HistoryImageViewer from "@/components/HistoryImageViewer.vue";
import StatusTag from '@/components/StatusTag.vue';
import IconBeus from '@/assets/images/ico-beus.svg';

import IconBi from '@/assets/images/ico-bi.svg';
import IconPV from '@/assets/images/ico-pv.svg';
import IconJam from '@/assets/images/ico-jam.svg';
import IconService from '@/assets/images/ico-service.svg';
import {useAuthorizedUsers} from "@/composables/useAuthorizedUsers";

interface RequestDetailCondition {
  requestType: RequestTypeKeys;
  beusPlanNumber: number | null;
  baPlanNumber: number | null;
}

interface Icon {
  condition: (detail: RequestDetailCondition) => boolean;
  src: string;
  alt: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewStatPage',
  props: {
    id: {},
    stat: {}
  },
  setup(__props: any) {

const router = useRouter();
const requestStore = useRequestStore();
const { isAuthorized } = useAuthorizedUsers()
const request = ref<RequestInfo | null>(null);
const isLoading = ref<boolean>(false);

const props = __props;

const fetchData = async (id: string) => {
  isLoading.value = true;
  const params = {
    requestId: id,
    ...(props.stat !== "NON_ISSUE" && { subId: requestStore.subId })
  }

  try {
    const response = await getRequestInfo(params);
    // console.log('Reqeust Info', response.result);

    if(response.result) {
      const { state } = response.result;
      const normalizedState = state ? state.trim().toUpperCase() : '';
      const normalizedPropsStat = props.stat ? props.stat.trim().toUpperCase() : '';

      // console.log(normalizedState, normalizedPropsStat);
      
      const specialCaseMap = {
        'TAX_INVOICE': ['DAY_INVOICE_TAX'],
        'QUOTATION': ['DAY_INVOICE'],
        'CONTRACT': ['DAY_INVOICE'],
        'INVOICE': ['DAY_INVOICE'],
        'TRANSACTION': ['DAY_INVOICE'],
        'SETTLEMENT': ['DAY_INVOICE']
      };
      
      const isMatching = normalizedState === normalizedPropsStat || 
        (specialCaseMap[normalizedState as keyof typeof specialCaseMap] && 
        specialCaseMap[normalizedState as keyof typeof specialCaseMap].includes(normalizedPropsStat));
      
      
      if (isMatching) {
        request.value = response.result;
        requestStore.setRequestData(response.result);
      } else {
        await ElMessageBox.alert('데이터를 가져올 수 없습니다. 대시보드로 이동합니다.', {
          confirmButtonText: '확인',
          callback: () => {
            router.push('/request');
          },
        });
      }
    }
  } catch (error) {
    console.error('Error Message:', error);
    ElMessageBox.alert('데이터를 가져올 수 없습니다. 대시보드로 이동합니다.', {
      confirmButtonText: '확인',
      callback: () => {
        router.push("/request");
      },
    });
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchData(props.id);
});

const icons: Icon[] = [
  {
    condition: ({ requestType, beusPlanNumber }: RequestDetailCondition) => 
      requestType === 'PLAN' && !!beusPlanNumber,
    src: IconBeus,
    alt: '플랜-히트맵',
  },
  {
    condition: ({ requestType, baPlanNumber }: RequestDetailCondition) => 
      requestType === 'PLAN' && !!baPlanNumber,
    src: IconBi,
    alt: '플랜-저니맵',
  },
  {
    condition: ({ requestType }: RequestDetailCondition) => 
      requestType === 'PV_CHARGE',
    src: IconPV,
    alt: 'PV 충전',
  },
  {
    condition: ({ requestType }: RequestDetailCondition) => 
      requestType === 'JAM_CHARGE',
    src: IconJam,
    alt: 'JAM 충전',
  },
  {
    condition: ({ requestType }: RequestDetailCondition) => 
      requestType === 'ADDITIONAL',
    src: IconService,
    alt: '부가서비스',
  },
];

const getFilteredIcons = (request: RequestInfo): Icon[] => {
  const detail = {
    requestType: request.detail.requestType,
    baPlanNumber: request.detail.baPlanNumber,
    beusPlanNumber: request.detail.beusPlanNumber
  }
  return icons.filter((icon) => icon.condition(detail));
};

const form: FormTask = reactive({
  isPlanCreated: false,
  attachedPlanScreen: null,
  isPVCharged: false,
  attachedPVScreen: null,
  isJamCharged: false,
  attachedJamScreen: null,
  isProcessedAdditionalService: false,
  isComfirmedPaymentWire: props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!request.value?.tasks.CONFIRMED_PAYMENT_WIRE : false,
  depositDate : null,
  isComfirmedPaymentCard: false,
  isSentRemindMail: props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!request.value?.tasks.SENT_REMIND_MAIL : false,
  attachedPaymentScreen: null,
  isIssuedInvoiceTax: false ,
  isIssuedInvoices: [false],
  isSentMailExtended: props.stat === 'NEED_TO_EXTEND' ? !!request.value?.tasks.SENT_MAIL_EXTEND : false,
  isConfirmedReply: props.stat === 'NEED_TO_EXTEND' ? !!request.value?.tasks.CONFIRMED_REPLY : false,
  isCreatedNewRequest: props.stat === 'NEED_TO_EXTEND' ? !!request.value?.tasks.CREATED_NEW_REQUEST : false,
  attachedScreen: null,
  isPlanNotExtended: false
});

const originalForm = ref<FormTask>(structuredClone(form));
// console.log('first', originalForm);

watch(request, (newRequest) => {
  if (!newRequest) return;

  form.isComfirmedPaymentWire = props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!newRequest.tasks.CONFIRMED_PAYMENT_WIRE : false;
  form.isSentRemindMail = props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!newRequest.tasks.SENT_REMIND_MAIL : false;
  form.isSentMailExtended = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.SENT_MAIL_EXTEND : false;
  form.isConfirmedReply = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.CONFIRMED_REPLY : false;
  form.isCreatedNewRequest = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.CREATED_NEW_REQUEST : false;
  form.isPlanNotExtended = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.DONT_NEED_TO_EXTEND : false;

  originalForm.value = structuredClone(form);
  // console.log('second', originalForm);
}, { deep: true });

// 플랜 연장 미진행 조건 변경 감지
watch([() => form.isSentMailExtended, () => form.isConfirmedReply, () => form.isCreatedNewRequest], () => {
  if (!isPlanNotExtendedEnabled.value && form.isPlanNotExtended) {
    form.isPlanNotExtended = false;
  }
});

const uploadLoading = ref<boolean>(false)

const isModified = computed(() => {
  return JSON.stringify(form) !== JSON.stringify(originalForm.value);
});

const isPlanNotExtendedEnabled = computed(() => {
  return form.isSentMailExtended && form.isConfirmedReply && !form.isCreatedNewRequest;
});

const selectedFile = ref<File | null>(null);

const handlePaste = (event: ClipboardEvent) => {
  const items = event.clipboardData?.items;
  if (!items) {
    ElNotification({
      title: '오류',
      message: '클립보드 데이터를 읽을 수 없습니다.',
      type: 'error',
    });
    return;
  }

  for (const item of items) {
    if (item.type.startsWith('image/')) {
      selectedFile.value = item.getAsFile();
      if (selectedFile.value) {
        form.attachedScreen = URL.createObjectURL(selectedFile.value);
        ElNotification({
          title: '성공',
          message: '이미지를 성공적으로 붙여넣었습니다.',
          type: 'success',
        });
      } else {
        ElNotification({
          title: '오류',
          message: '이미지를 처리하는 데 실패했습니다.',
          type: 'error',
        });
      }
      return;
    }
  }
  ElNotification({
    title: '오류',
    message: '붙여넣은 데이터에서 이미지를 찾을 수 없습니다.',
    type: 'warning',
  });
};

const handleRemoveImage = () => {
  Object.assign(form, { attachedScreen: null });
}

const uploadImage = async () => {
  console.log('Upalod Image...')
  if (!selectedFile.value) {
    console.error('No Image!');
    ElMessage.error('이미지를 찾을 수 없습니다.');
    return false;
  }

  const formData = new FormData();
  const newFileName = `${requestStore.requestId}_${props.stat.toLowerCase()}_${moment().format('YYYYMMDDHHmmss')}.png`
  formData.append('image', selectedFile.value, newFileName);
  // formData.forEach((value, key) => {
  //   console.log(key, value);
  // });

  try {
    const response = await uploadImagetoServer(formData);
    // console.log(`Upload successful!: ${response.result}`);
    if (response.result) {
      return response.result;
    } else return null;
  } catch (error) {
    console.error('Upload failed:', error);
    ElMessage.error('이미지를 업로드하는데 실패했습니다. 다시 시도해주세요.');
    return null;
  }
};

const handleSubmit = async () => {
  if (uploadLoading.value) return
  uploadLoading.value = true
  let fileName = null;

  if(form.isPlanCreated || form.isPVCharged || form.isJamCharged || form.isComfirmedPaymentCard) {
    try {
      fileName = await uploadImage();
    } catch (error) {
      console.error('이미지 업로드 실패:', error);
      uploadLoading.value = false
      return;
    }

    if (!fileName) {
      ElMessageBox.alert('스크린 캡쳐는 필수입니다.', {
        confirmButtonText: '확인',
      });
      uploadLoading.value = false
      return;
    }
    
  } else fileName = null;

  if(form.isComfirmedPaymentWire) {
    if (!form.depositDate) {
      ElMessageBox.alert('입금일 지정은 필수입니다.', {
        confirmButtonText: '확인',
      });
      return;
    }
  }

  if(!request.value?.detail.recurring) {
    if((form.isSentMailExtended === false && form.isConfirmedReply) || (form.isSentMailExtended === false && form.isCreatedNewRequest)) {
      ElMessageBox.alert('연장 메일 발송이 먼저 수행되어야 합니다.', {
        confirmButtonText: '확인',
      });
      return;
    }

    if((form.isConfirmedReply === false && form.isCreatedNewRequest)) {
      ElMessageBox.alert('답신 확인 후 리퀘스트 생성이 수행되어야 합니다.', {
        confirmButtonText: '확인',
      });
      return;
    }
  }

  const taskMappings: Record<string, any> = {
    CREATED_REQUEST_PLAN: {
      CREATED_EAGLE_PLAN: form.isPlanCreated,
      ATTACHED_PLAN_SCREEN: fileName
    },
    CREATED_REQUEST_PV: {
      CHARGED_EAGLE_PV: form.isPVCharged,
      ATTACHED_PV_SCREEN: fileName
    },
    CREATED_REQUEST_JAM: {
      CHARGED_EAGLE_JAM: form.isJamCharged,
      ATTACHED_JAM_SCREEN: fileName
    },
    CREATED_REQUEST_ADDITIONAL: {
      PROCESSED_ADDITIONAL_SERVICE: form.isProcessedAdditionalService
    },
    DAY_PAYMENT_WIRE: {
      CONFIRMED_PAYMENT_WIRE: form.isComfirmedPaymentWire,
      DATE_PAYMENT_WIRE: moment(form.depositDate).format('YYYY-MM-DD')
    },
    DAY_PAYMENT_WIRE_DELAY: {
      SENT_REMIND_MAIL: form.isSentRemindMail,
      CONFIRMED_PAYMENT_WIRE: form.isComfirmedPaymentWire,
      DATE_PAYMENT_WIRE: moment(form.depositDate).format('YYYY-MM-DD')
    },
    DAY_PAYMENT_CARD: {
      CONFIRMED_PAYMENT_CARD: form.isComfirmedPaymentCard,
      ATTACHED_PAYMENT_SCREEN: fileName
    },
    DAY_INVOICE_TAX: {
      ISSUED_INVOICE_TAX: form.isIssuedInvoiceTax
    },
    DAY_INVOICE: {
      ISSUED_INVOICE: form.isIssuedInvoices
    },
    NEED_TO_EXTEND: (request: Ref<RequestInfo | null>) => {
      if (request.value?.detail.recurring) {
        return {
          CREATED_NEW_REQUEST: form.isCreatedNewRequest
        };
      } else {
        return {
          SENT_MAIL_EXTEND: form.isSentMailExtended,
          CONFIRMED_REPLY: form.isConfirmedReply,
          CREATED_NEW_REQUEST: form.isCreatedNewRequest,
          DONT_NEED_TO_EXTEND: form.isPlanNotExtended
        };
      }
  },
    NON_ISSUE: {},
    COMPLETED_REQUEST: {}
  };
  const updatedTasks =
  typeof taskMappings[props.stat] === "function"
    ? taskMappings[props.stat](request)
    : taskMappings[props.stat] || {};

  const formData = {
    requestId: requestStore.requestId,
    subId: requestStore.subId,
    tasks: updatedTasks
  }
  try {
    console.log('formData', formData)
    console.log('requestStore.requestId:', requestStore.requestId)
    console.log('requestStore.subId:', requestStore.subId)
    
    const response = await updateTask(formData);
    console.log('과업 성공:', response);
    
    // 응답 구조 확인
    if (response && (response.success || response.result)) {
      ElMessageBox.alert('과업을 저장했습니다. 보드로 이동합니다', {
        confirmButtonText: '확인',
        callback: () => {
          router.push("/request");
        },
      });
    } else {
      console.error('응답 구조 문제:', response);
      ElMessage.error('과업 저장에 실패했습니다. 다시 시도해주세요')
    }
  }
  catch (error) {
    console.error('Error message:', error)
    console.error('Error details:', error instanceof Error ? error.message : String(error))
    ElMessage.error('과업 저장에 실패했습니다. 다시 시도해주세요')
  } finally {
    uploadLoading.value = false
  }
}

const handleCancel = () => {
  ElMessageBox.confirm(
    '과업을 저장하지 않고 보드로 이동합니다', {
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    })
    .then(() => { router.push("/request"); })
    .catch(() => { return false; })
}

const showImageViewer = ref(false);
const currentImage = ref('');
const openImageViewer = (url = '') => {
  currentImage.value = url;
  showImageViewer.value = true;
};
const closeImageViewer = () => {
  showImageViewer.value = false;
};

const requiredLogTypes = [
  'CREATED_EAGLE_PLAN',
  'CREATED_EAGLE_PV',
  'CREATED_EAGLE_JAM',
  'PROCESSED_REQUEST_ADDITIONAL',
];

const isModifiable = computed(() => {
  const hasRequiredLog = requiredLogTypes.some((logType) => {
    const exists = request.value?.history.some((item) => item.logType === logType);
    return exists;
  });

  if (!hasRequiredLog) {
    return true;
  }

  const isBeforeToday = request.value ? new Date(request.value.detail.useStartDate) > new Date() : false;

  if(request.value?.history.some((item) => item.logType === 'CREATED_EAGLE_PLAN')) return isBeforeToday;
  else return false;
});

const handleModifyRequest = () => router.push(`/request/modify/${props.id}`);

const isDeletable = computed(() => {
  const hasRequiredLog = requiredLogTypes.some((logType) => {
    const exists = request.value?.history.some((item) => item.logType === logType);
    return exists;
  });

  if (!hasRequiredLog) {
    return true;
  }

  const isBeforeToday = request.value ? new Date(request.value.detail.useStartDate) > new Date() : false;
  return isBeforeToday;
});

const handleDeleteRequest = async () => {
  try {
    await ElMessageBox.confirm(
      '리퀘스트를 정말 삭제하시겠습니까?<br/>삭제한 리퀘스트는 복구할 수 없습니다.',
      '경고',
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }
    );
    
    const params = { requestId: props.id }
    const response = await removeRequest(params);

    if(response.success) {
      ElMessage({
        message: '삭제가 완료되었습니다.',
        type: 'success',
      });
      router.push({name: 'Board'});
    }

  } catch (error) {
    if (error === 'cancel') {
      return;
    }
    console.error('Error messege:', error);
    ElMessage({
      message: '삭제 중 오류가 발생했습니다.',
      type: 'error',
    });
  }
}
const toCurrentPlanList = () => router.push({ path: '/request/plan', query: { param: request.value?.customer.customerId } });
const toCurrentPaymentList = () => router.push({ path: '/request/payment', query: { param: request.value?.customer.customerId } });

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (request.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(request.value.customer.companyName), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFilteredIcons(request.value), (icon, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: index,
                  src: icon.src,
                  alt: icon.alt
                }, null, 8, _hoisted_4))
              }), 128)),
              _createVNode(StatusTag, {
                color: _unref(getTagColor)(_ctx.stat),
                size: "large",
                text: _unref(getRequestStatusTypeValue)(_ctx.stat)
              }, null, 8, ["color", "text"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-left" }),
                    _cache[15] || (_cache[15] = _createTextVNode(" 뒤로가기 "))
                  ]),
                  _: 1
                }),
                (_unref(isAuthorized))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "large",
                      type: "primary",
                      class: "btn-edit",
                      onClick: handleModifyRequest
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode(" 수정 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (isDeletable.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "large",
                      type: "primary",
                      class: "btn-edit",
                      onClick: handleDeleteRequest
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode(" 삭제 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (request.value.detail.requestType === 'PLAN')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      size: "large",
                      onClick: toCurrentPlanList
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-list" }),
                        _cache[18] || (_cache[18] = _createTextVNode(" 플랜 "))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  onClick: toCurrentPaymentList
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-list" }),
                    _cache[19] || (_cache[19] = _createTextVNode(" 결제 "))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(ViewDetail, { data: request.value }, null, 8, ["data"]),
            (_ctx.stat !== 'NON_ISSUE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "tit-h3" }, " 과업 수행 ", -1)),
                  _createVNode(_component_el_form, {
                    model: form,
                    "label-position": "left",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_el_form_item, { label: "플랜 생성 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isPlanCreated,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.isPlanCreated) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'CREATED_REQUEST_PLAN']
                      ]),
                      (form.isPlanCreated)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "screen",
                            onPaste: handlePaste
                          }, [
                            _createElementVNode("div", _hoisted_7, [
                              (!form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요. "))
                                : _createCommentVNode("", true),
                              (form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: form.attachedScreen,
                                    alt: "Pasted preview"
                                  }, null, 8, _hoisted_9))
                                : _createCommentVNode("", true)
                            ]),
                            (form.attachedScreen)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  text: "",
                                  "aria-label": "삭제",
                                  onClick: handleRemoveImage
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-trash-can" })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 32))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "PV 충전 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isPVCharged,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.isPVCharged) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'CREATED_REQUEST_PV']
                      ]),
                      (form.isPVCharged)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "screen",
                            onPaste: handlePaste
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              (!form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요. "))
                                : _createCommentVNode("", true),
                              (form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: form.attachedScreen,
                                    alt: "Pasted preview"
                                  }, null, 8, _hoisted_12))
                                : _createCommentVNode("", true)
                            ]),
                            (form.attachedScreen)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  text: "",
                                  "aria-label": "삭제",
                                  onClick: handleRemoveImage
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-trash-can" })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 32))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "Jam 충전 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isJamCharged,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.isJamCharged) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'CREATED_REQUEST_JAM']
                      ]),
                      (form.isJamCharged)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "screen",
                            onPaste: handlePaste
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              (!form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " 이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요. "))
                                : _createCommentVNode("", true),
                              (form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: form.attachedScreen,
                                    alt: "Pasted preview"
                                  }, null, 8, _hoisted_15))
                                : _createCommentVNode("", true)
                            ]),
                            (form.attachedScreen)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  text: "",
                                  "aria-label": "삭제",
                                  onClick: handleRemoveImage
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-trash-can" })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 32))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_el_form_item, { label: `부가서비스\n처리 여부` }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isProcessedAdditionalService,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.isProcessedAdditionalService) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'CREATED_REQUEST_ADDITIONAL']
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "입금 리마인드 메일 발송" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isSentRemindMail,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.isSentRemindMail) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'DAY_PAYMENT_WIRE_DELAY']
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "입금 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isComfirmedPaymentWire,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.isComfirmedPaymentWire) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'DAY_PAYMENT_WIRE' || _ctx.stat === 'DAY_PAYMENT_WIRE_DELAY']
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "입금일" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: form.depositDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.depositDate) = $event)),
                            type: "date",
                            placeholder: "선택하세요",
                            size: "large",
                            style: {"width":"150px"},
                            clearable: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, form.isComfirmedPaymentWire]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "카드 결제 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isComfirmedPaymentCard,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.isComfirmedPaymentCard) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'DAY_PAYMENT_CARD']
                      ]),
                      (form.isComfirmedPaymentCard)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: "screen",
                            onPaste: handlePaste
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              (!form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, " 이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요. "))
                                : _createCommentVNode("", true),
                              (form.attachedScreen)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: form.attachedScreen,
                                    alt: "Pasted preview"
                                  }, null, 8, _hoisted_18))
                                : _createCommentVNode("", true)
                            ]),
                            (form.attachedScreen)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  text: "",
                                  "aria-label": "삭제",
                                  onClick: handleRemoveImage
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-trash-can" })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 32))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "세금계산서 발행 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isIssuedInvoiceTax,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.isIssuedInvoiceTax) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'DAY_INVOICE_TAX']
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, {
                        label: `${_unref(getDocumentTypeValue)(request.value.state as DocumentTypeKeys)} 발행 여부`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isIssuedInvoices,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.isIssuedInvoices) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[36] || (_cache[36] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[37] || (_cache[37] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]), [
                        [_vShow, _ctx.stat === 'DAY_INVOICE']
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "연장 메일 발송 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isSentMailExtended,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.isSentMailExtended) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[38] || (_cache[38] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[39] || (_cache[39] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'NEED_TO_EXTEND' && !request.value.detail.recurring]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "답신 확인" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isConfirmedReply,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.isConfirmedReply) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[41] || (_cache[41] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'NEED_TO_EXTEND' && !request.value.detail.recurring]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "신규 리퀘스트 생성 여부" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isCreatedNewRequest,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.isCreatedNewRequest) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[42] || (_cache[42] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[43] || (_cache[43] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'NEED_TO_EXTEND']
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { label: "플랜 연장 미진행" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: form.isPlanNotExtended,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.isPlanNotExtended) = $event)),
                            disabled: !isPlanNotExtendedEnabled.value
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { value: true }, {
                                default: _withCtx(() => _cache[44] || (_cache[44] = [
                                  _createTextVNode(" 예 ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { value: false }, {
                                default: _withCtx(() => _cache[45] || (_cache[45] = [
                                  _createTextVNode(" 아니오 ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.stat === 'NEED_TO_EXTEND' && !request.value.detail.recurring]
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large",
                      disabled: !isModified.value || uploadLoading.value,
                      onClick: handleSubmit
                    }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createTextVNode(" 과업 저장 ")
                      ])),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "default",
                      size: "large",
                      onClick: handleCancel
                    }, {
                      default: _withCtx(() => _cache[47] || (_cache[47] = [
                        _createTextVNode(" 취소 ")
                      ])),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_20, [
              _cache[49] || (_cache[49] = _createElementVNode("h3", { class: "tit-h3" }, " 히스토리 ", -1)),
              _createVNode(HistoryList, {
                data: request.value,
                onOpenImageViewer: openImageViewer
              }, null, 8, ["data"])
            ])
          ], 64))
        : (_openBlock(), _createBlock(CommonLoader, { key: 1 }))
    ]),
    (showImageViewer.value)
      ? (_openBlock(), _createBlock(HistoryImageViewer, {
          key: 0,
          url: currentImage.value,
          onClose: closeImageViewer
        }, null, 8, ["url"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})